import {
  Box,
  createStyles,
  ScrollArea,
  Text,
  Table,
  Button,
  Center,
} from "@mantine/core";

import React, { useEffect, useState } from "react";

import { RiFilter3Line } from "react-icons/ri";
import { getAllBillingModal, getBillingCache } from "../../services";
import { useSelector } from "react-redux";
import TableLoader from "../TableLoader";
import ClaimFilter from "./ClaimFilter";
import BillingSearchAll from "../Document/BilllingSearchAll";
import CustomBillingPagination from "../Pagination/CustomBillingPagination";
import RecordNotFound from "../RecordNotFound";
import { useNavigate } from "react-router-dom";


// import RecordNotFound from "../../../RecordNotFound";

const useStyles = createStyles((theme) => ({
  header: {
    position: "sticky",
    top: 0,
    zIndex: 1,
    borderRadius: "16px",
    transition: "box-shadow 150ms ease",
    "& th": {
      backgroundColor: "#F2F2F2",
      color: "#000 !important",
    },
    "& th:first-of-type": {
      borderTopLeftRadius: "16px !important",
      borderBottomLeftRadius: "16px !important",
    },
    "& th:last-of-type": {
      borderTopRightRadius: "16px !important",
      borderBottomRightRadius: "16px !important",
    },
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
    },
  },

  bg1: {
    "& td": {
      background: "#fff",
    },
  },
  bg2: {
    "& td": {
      background: "#F9FAFB",
    },
  },

      pending: {
    padding: "2px 8px 2px 6px",
    width: "52%",
    margin: "auto 0",
    borderRadius: "16px",
    background: "#F9F5FF",
  },



  item: {
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    marginBottom: "8px",
    overflow: "hidden",
    background: "#fff",
    padding: "0px",
  },

  clientInfoCardDataParent: {
    display: "flex",
    justifyContent: "space-between !important",
    gap: "73px",
    "@media (max-width:1200px)": {
      gap: "10px",
    },
  },

  notFoundText: {
    color: "#A8A8A8",
    fontFamily: "Inter",
    fontSize: "22px",
    fontStyle: "normal",
    fontWeight: "400",
    lineHeight: "normal",
    justifyContent: "center",
  },

  searchbox: {
    // marginTop: "20px",
    // marginBottom: "20px",
    width: "30%",
    padding: "none !important",
    border: "none !important",

    "@media (max-width:1200px)": {
      width: "100%",
    },
    // marginTop: "50px",
  },

  flexend: {
    display: "flex",
    justifyContent: "flex-end",
  },

  newrow: {
    margin: "auto",
    //  width: "30%",
    display: "flex",
    justifyContent: "center",

    "@media (max-width:1300px)": {
      width: "55%",
    },
    "@media (max-width:500px)": {
      width: "95%",
    },
  },

  flex: {
    display: "flex",
    justifyContent: "space-between",

    "@media (max-width:1200px)": {
      gap: "10px",
      flexDirection: "column",
      alignItems: "center",
    },
  },

  mainaccord: {
    width: "100%",
    // padding: "14px 12px",
    // background: "#F9FAFB",
  },

  accordionbox: {
    display: "flex",
    alignItems: "center",
    // justifyContent: "space-between",
    // padding: "14px 12px",
    // background: "#F9FAFB",
    gap: "4px",
  },

  gap: {
    display: "flex",
    gap: "20px",
  },

  scrolled: {
    boxShadow: theme.shadows.sm,
    borderRadius: "15px",
  },
  tableHeader: {
    borderBottom: "none !important",
  },
  accordionExpandedContent: {
    minHeight: "auto",
    maxHeight: "250px",
    overflowY: "auto",
  },
  button: {
    "&:hover": {
      background: "#FFAF4A",
      color: "#000",
      opacity: 0.8,
    },
  },

  exportbutton: {
    "&:hover": {
      background: "grey",
      color: "#000",
      opacity: 0.8,
    },
  },

  tablenewHeader: {
    color: "#000 !important",
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "700 !important",
  },

  tablenewRow: {
    color: "#000 !important",
    fontFamily: "Inter !important",
    fontSize: "14px !important",
    fontWeight: "400 !important",
  },

  rejected: {
    padding: "2px 8px 2px 6px",
    width: "52%",
    margin: "auto 0",
    borderRadius: "16px",
    background: "#FEF3F2",
  },

  accepted: {
    padding: "2px 8px 2px 6px",
    width: "52%",
    margin: "auto 0",
    borderRadius: "16px",
    background: "#ECFDF3",
  },

  acknowledged: {
    padding: "2px 8px 2px 6px",
    width: "52%",
    margin: "auto 0",
    borderRadius: "16px",
    background: "#F9F5FF",
  },





  

  previousclaims: {
    background: "#FFF",
    padding: "12px 8px",
    width: "98%",
    borderRadius: "16px",
    marginBottom: "20px",
  },

  textbox: {
    marginTop: "29px",
    marginBottom: "7px",
    alignSelf: "flex-start",
    marginLeft: "20px",
  },
}));

function DraftClaims({
}) {
  const { classes, cx } = useStyles();
  const [scrolled, setScrolled] = useState(false);
  const [filtermodal, setFilterModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [billingsearch, setBillingSearch] = useState("");
const { billingcache,loading } = useSelector((state) => state?.billing);

  // console.log("allBilling", allBilling);

  // console.log('billingsearch',billingsearch);

  const navigate = useNavigate();

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };



  useEffect(() => {
    getBillingCache({ page: currentPage });
  }, [currentPage]);




  // view billing info
  const handleIconClick = (billingItem) => {


     navigate('/home/billing-claim-form', {
      state: { billingItem },
    });
    
    // setDecryptedBillingData(billingItem);
    // setClaimDetails(true);
  };

  const SearchBilling = async (searchValue) => {
    let paylaod = {
      name: billingsearch,
    };

    console.log("API Call: Search for ", billingsearch);

    try {
      await getAllBillingModal(paylaod);
    } catch (error) {
      console.error("API call error:", error);
    }
  };

  const allbilling = loading ? (
    <TableLoader />
  ) : (
    <ScrollArea
      onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
      sx={{ minHeight: "300px" }}
    >
      <Table
        highlightOnHover={true}
        enableStickyHeader={true}
        sx={{
          fontFamily: "Inter",
          borderRadius: "5px",
          border: "1px solid #E5E5E5",
          marginTop: "20px",
        }}
        fontSize={"sm"}
        verticalSpacing={"md"}
      >
        <thead>
          <tr>
            <th></th>
            <th>
              <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                Payer Name
              </Text>
            </th>
            <th className={classes.header}>
              <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                Provider Name
              </Text>
            </th>
            <th className={classes.header}>
              <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                Provider Type
              </Text>
            </th>
            <th className={classes.header}>
              <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                Payer ID
              </Text>
            </th>
            <th className={classes.header}>
              <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                No Of Clients
              </Text>
            </th>
            <th className={classes.header}>
              <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
                Claim ID
              </Text>
            </th>
            <th className={classes.header}>
              <Text ff={"Inter"} fz={"14px"} fw={"700"} color={"#000"}>
              No Of Services
              </Text>
            </th>
          
            <th className={classes.header}></th>
          </tr>
        </thead>
   <tbody>
  {billingcache?.billingcache?.length > 0 ? (
    billingcache.billingcache.map((item, index) => {
      const bg = index % 2 === 0 ? classes.bg2 : classes.bg1;

      return (
        <tr
          style={{ cursor: "pointer" }}
          onClick={() => handleIconClick(item)}
          key={item?._id || index}
          className={bg}
        >
          <td>


     <Box
                          // className={
                          //   claim?.status === "R"
                          //     ? classes.rejected
                          //     : classes.accepted
                          // }
                          className={classes.pending}
                        >
                          <Text
                            ta={"center"}
                            fs={12}
                            fw={500}
                            
                            style={{ width: "max-content", margin:'auto', }}
                            // color={
                            //   claim?.status === "R" ? "#B42318" : "#027A48"
                            // }
                            // color={
                            //   claim?.status === "R"
                            //     ? "#B42318"
                            //     : claim?.status === "A"
                            //     ? "#6941C6"
                            //     : "#027A48"
                            // }
                            color="#6941C6"
                          >
                            <span
                              style={{
                                display: "inline-block",
                                width: "8px",
                                height: "8px",
                                borderRadius: "50%",
                               

                                backgroundColor:"#F9F5FF",
                                  // claim?.status === "R"
                                  //   ? "#B42318"
                                  //   : "#027A48",
                                  // claim?.status === "R"
                                  //   ? "#B42318"
                                  //   : claim?.status === "A"
                                  //   ? "#9E77ED"
                                  //   : "#027A48",

                        
                                marginRight: "5px",
                                verticalAlign: "middle",
                              }}

                            
                            >

                               
                            </span>
Draft
                       
                            
                          </Text>
                        </Box>

          </td>
          <td>
            <Text ff={"Inter"} fz={"14px"} fw={"400"} color={"#000"}>
              {item?.payer?.payerName}
            </Text>
          </td>
          <td>
            <Text ff={"Inter"} fz={"14px"} fw={"400"} color={"#000"}>
                {item?.provider?.name}
            </Text>
          </td>
          <td>
            <Text ff={"Inter"} fz={"14px"} fw={"400"} color={"#000"}>
                        {item?.provider?.providertype}
            </Text>
          </td>
          <td>
            <Text ff={"Inter"} fz={"14px"} fw={"400"} color={"#000"}>
            
                      {item?.payer?.payerId}
            </Text>
          </td>
          <td>
            <Text ff={"Inter"} fz={"14px"} fw={"400"} color={"#000"}>
              {item?.client?.length}
            </Text>
          </td>
          <td>
            <Text ff={"Inter"} fz={"14px"} fw={"400"} color={"#000"}>
              837p
            </Text>
          </td>
          <td>
                  {item?.billingServices?.length}
            {/* 
            <Text ff={"Inter"} fz={"14px"} fw={"400"} color={"#000"}>
              {item?.createdAt
                ? new Date(item?.createdAt).toLocaleDateString("en-US")
                : "Date Not Available"}
            </Text> 
            */}
          </td>
      
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan={1000}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-evenly",
            height: "55vh",
            gap: "8rem",
          }}
        >
          <RecordNotFound />
          <Center>
            <p className={classes.notFoundText}>
              You don&apos;t have any record, Add Billing
            </p>
          </Center>
        </div>
      </td>
    </tr>
  )}
</tbody>

      </Table>
      <Center>
        <CustomBillingPagination
          data={billingcache?.count}
          itemsPerPage={10}
          currentPage={currentPage}
          handlePageChange={handlePageChange}
        />
      </Center>
    </ScrollArea>
  );

  // console.log('decryptedBillingData?.billingForm?.claim?.length',decryptedBillingData?.billingForm?.claim?.length);



  return (
    <>
      <Box className={classes.previousclaims}>
        <Box className={classes.flex}>
          {/* <Box className={classes.searchbox}>
            <BillingSearchAll
              placeholder="Search Payer ID, Provider name, Payer name"
              onChange={SearchBilling}
              value={billingsearch}
              setValue={setBillingSearch}
            />
          </Box> */}

          {/* <Box className={classes.gap}>
            <Button
              // className={classes.exportbutton}
              onClick={() => {
                setFilterModal(true);
              }}
              variant="fixed"
              c={"#000"}
              bg={"#F9FAFB"}
              radius="md"
              size="md"
            >
              <RiFilter3Line size={20} color="#000" variant="default" />
              Filter
            </Button>

          </Box> */}
        </Box>

    <Box>{allbilling}</Box> 
      </Box>



      <ClaimFilter filtermodal={filtermodal} setFilterModal={setFilterModal} />
    </>
  );
}

export default DraftClaims;
